skrilla.directive('excludedPersonsRegister',function() {
    return {
        templateUrl: 'directives/excludedPersonsRegister/excludedPersonsRegister.html',
        scope: {},
        controller: async function ($scope, searchService, queryService, paginationService, cacheService, modalService,
                                    $stateParams, userExclusionsService, sportService, addressService) {
            $scope.pageKey = "excludedUsers";
            $scope.sports = await sportService.getSports()
            $scope.reset = function () {
                $scope.query = {
                    firstName: "",
                    lastName: "",
                    email: "",
                    phone: "",
                    streetNumber: "",
                    street: "",
                    postCode: "",
                    suburb: "",
                    state: "",
                    country: "",
                    requester: [],
                    exclusionType: "",
                    excludedSports: null,
                    limit: 20
                };
            };
            $scope.resetSearchParam = function(searchParam) {
                if (searchParam === 'requester') $scope.query.requester = []
                else if (searchParam === 'excludedSports') $scope.query.excludedSports = null
            }
            userExclusionsService.getExclusionTypes().then(function (exclusionTypes) {$scope.exclusionTypes = exclusionTypes})
            userExclusionsService.getRequesterTypes('person').then(function (requesters) {$scope.requesters = requesters})
            $scope.reset();

            $scope.search = function(){
                if ($scope.query.exclusionType === 'PRODUCT') $scope.resetSearchParam('excludedSports')
                paginationService.resetPage($scope.pageKey);
                paginationService.pageQuery(getPersons, $scope.pageKey);
            }

            $scope.formatAddress = function (user) {
                return addressService.formatAddress(user)
            }

            const getPersons = function() {
                return searchService.get("excludedPersonsRegister" + queryService.getQueryString($scope.query, $scope.pageKey)).then(function(response){
                    $scope.persons = response.data.result;
                    paginationService.setPage($scope.pageKey, paginationService.buildPage(response));
                });
            }

            $scope.openExcludedPersonsModal = function(person) {
                person = person || {}
                cacheService.registerObject($scope.pageKey, person);
                modalService.openModal("views/excludedPersons/excludedPersonsModal.html", true, 'lg', true, true, function() {
                    let isSportsPerson = cacheService.getObject('sportsPerson')
                    let savedExclusions = cacheService.getObject('sportsExclusions')
                    if (isSportsPerson && !savedExclusions) {
                        searchService.deleteRequest("excludedPersonsRegister/" + isSportsPerson.id, "deleted").then(function () {
                            modalService.error("This person has been deleted as no sports exclusions were created")
                        })
                    }
                })
                $scope.search()
            }

            $scope.effectiveUntilColour = function (date) {
                return userExclusionsService.getEffectiveUntilColour(date)
            }

            if($stateParams.excludedPersonId){
                searchService.get("excludedPersonsRegister/" + $stateParams.excludedPersonId).then(function(response){
                    $scope.persons = [response.data];
                    $scope.openExcludedPersonsModal(response.data);
                });
            }
            else{
                $scope.search();
            }
        }
    };
});